export enum DatePreset {
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  TwoDays = '2 days',
  ThreeDays = '3 days',
  OneWeek = '1 week',
  TwoWeeks = '2 weeks',
  ThreeWeeks = '3 weeks',
}
